var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cart" }, [
    _c(
      "ul",
      _vm._l(_vm.cartItems, function(item, ii) {
        return _c(
          "li",
          [
            item.type == "discount"
              ? [
                  _vm._v("\n        Discount "),
                  _c("span", { staticClass: "price" }, [
                    _vm._v("$ " + _vm._s((item.price * 1 || 0).toFixed(2)))
                  ])
                ]
              : [
                  item.type == "membership"
                    ? _c("span", { staticClass: "title" }, [
                        _vm._v("Membership")
                      ])
                    : _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(
                            item.video ? item.video.title : item.group.title
                          )
                        )
                      ]),
                  _vm._v(" "),
                  item.type == "membership"
                    ? _c("span", { staticClass: "price" }, [_vm._v("$ 129.00")])
                    : _c("span", { staticClass: "price" }, [
                        _vm._v(
                          _vm._s(_vm.formatPrice(item.price[0], item.price[1]))
                        )
                      ]),
                  _vm._v(" "),
                  item.duration
                    ? _c("span", { staticClass: "duration" }, [
                        _vm._v(_vm._s(item.duration) + " days")
                      ])
                    : _vm._e()
                ]
          ],
          2
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.cartItems && _vm.cartItems.length
      ? _c("div", { staticClass: "total" }, [
          _c("span", { staticClass: "total-price" }, [
            _vm._v("$ " + _vm._s(_vm.totalPrice))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "label" }, [_vm._v("IN TOTAL")])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }